import { observer } from 'mobx-react-lite'
import { type DocumentManagementViewModel } from '@/features/documents/DocumentManagementViewModel'
import { DocumentCount } from '@/features/documents/components/DocumentManagementTable/DocumentCount'

export interface DocumentCountContainerProps {
  vm: DocumentManagementViewModel
}

export const DocumentCountContainer = observer(function DocumentCountContainer({
  vm,
}: DocumentCountContainerProps) {
  return (
    <DocumentCount
      totalDocuments={vm.searcher.totalDocuments}
      archivedFilterValue={vm.searcher.archivedFilterValue}
    />
  )
})
